const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();

function videoControl(action,target){
  var $playerWindow = $(target)[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
}





// ------------------------------------------------------------------------
// loading
// ----- BOTH
// ------------------------------------------------------------------------
const loading = () => {
  $(window).on("load", function() {
    $(".st-Load").addClass("loaded");
  });
  setTimeout(function(){
    $(".st-Load").addClass("loaded");
  },3000);
};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};



// ------------------------------------------------------------------------
// mainSlider
// ----- BOTH
// ------------------------------------------------------------------------
const mainSlider = () => {
  $('.mv-slider').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    dots: true,
    speed: 800,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    focusOnSelect: true,
    responsive:[
      {
          breakpoint: 1024,
          settings:{
              slidesToShow:1,
          }
      },
    ]
  });
};


// ------------------------------------------------------------------------
// resizeHeader
// ----- BOTH
// ------------------------------------------------------------------------
const resizeHeader = () => {
  $(window).on("load scroll", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 200) {
      $(".st-Header").addClass("scrolled");
    } else {
      $(".st-Header").removeClass("scrolled");
    }
  });
};


// ------------------------------------------------------------------------
// movieSlider
// ----- BOTH
// ------------------------------------------------------------------------
const movieSlider = () => {
  $('.movie-slider').slick({
    arrows: false,
    dots: true,
    infinite: false,
    speed: 500,
    fade: true,
    cssEase: 'ease',
    customPaging: function(slick,index) {
        var targetImage = slick.$slides.eq(index).find('.movie-bg').attr('data-url');
        return '<button style="background: #000 url(' + targetImage + ') no-repeat center center/cover"/>';
    }
  });
  $(".movie-wrapper").on("click", function() {
    $(this).addClass("play");
    videoControl("playVideo",$(this).children('iframe'));
  });
};


// ------------------------------------------------------------------------
// recoSlider
// ----- BOTH
// ------------------------------------------------------------------------
const recoSlider = () => {
  $('.reco-slider').slick({
    // autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    variableWidth: true,
    focusOnSelect: true,
    responsive:[
      {
          breakpoint: 768,
          settings:{
              slidesToShow:2,
          }
      },
    ]
  });
};


// ------------------------------------------------------------------------
// accToggle
// ----- BOTH
// ------------------------------------------------------------------------
const accToggle = () => {
  $(".acc-toggle").on("click", function() {
    $(this).toggleClass("open");
    $(this).prev().toggleClass("open");
    $(this).prev().slideToggle(300);
  });
  $(".acc-head-toggle").on("click", function() {
    $(this).parent().toggleClass("open");
    $(this).parent().next().slideToggle(300);
  });
};


// ------------------------------------------------------------------------
// scrlInit
// ----- BOTH
// ------------------------------------------------------------------------
const scrlInit = () => {
  $('.store-list').each(function(i,e) {
    let listWidth = $(e).outerWidth();
    let itemWidth = 0;
    // 子要素のmargin含む横幅の合計値を取得
    $(e).children('.store-item').each(function(i,e) {
      itemWidth += $(e).outerWidth(true);
    })
    // 子要素の幅合計が親を上回っていたらスクロールバー適用
    if(listWidth < itemWidth){
      $(e).addClass('store-list_scroll');
      $(e).parent().addClass('nopadding');
      new SimpleBar($(e)[0],{
        autoHide: false
      });
    }
  });
  // マウスホイールでスクロール
  if (matchMedia('(max-width: 1023px)').matches) {
  } else {
    let horiElm = $('[data-simplebar]');
    for (let elm of horiElm)
    elm.onwheel = (event) => {
      event.preventDefault();
      let elmToScroll = elm.querySelector('.simplebar-content-wrapper');
      clearTimeout(elmToScroll.timer);
      elmToScroll.timer = setTimeout(() => {
        elmToScroll.scrollTo({ left: event.deltaY > 0 ? elmToScroll.scrollLeft + 250 : elmToScroll.scrollLeft - 250, behavior: 'smooth' });
      }, 20);
    };
  }
};


// ------------------------------------------------------------------------
// inputSync
// ----- BOTH
// ------------------------------------------------------------------------
const inputSync = () => {
  let count = 0;
  $(".sw-Game_Searchbox form input[type='checkbox'],.sw-Game_Searchbox form input[type='radio']").change( function() {
    let name = $(this).attr('name');
    let value = $(this).attr('value');
    let isChecked = $(this).prop('checked');
    if(name == 'pl[]' && isChecked){
      $('<input type="hidden" name="pl[]" value="'+value+'">').insertBefore('.freeword input[type="text"]');
    } else if(name == 'pl[]' && !isChecked) {
      $('.freeword input[value="'+value+'"]').remove();
    }
    if(name == 'gr[]' && isChecked){
      $('<input type="hidden" name="gr[]" value="'+value+'">').insertBefore('.freeword input[type="text"]');
    } else if(name == 'gr[]' && !isChecked) {
      $('.freeword input[value="'+value+'"]').remove();
    }
    if(name == 'order' && value == 'published'){
      $('.freeword input[value="scheduled"]').remove();
      $('<input type="hidden" name="order" value="'+value+'">').insertBefore('.freeword input[type="text"]');
    } else if(name == 'order' && value == 'scheduled') {
      $('.freeword input[value="published"]').remove();
      $('<input type="hidden" name="order" value="'+value+'">').insertBefore('.freeword input[type="text"]');
    }
  });
  $(".sw-Game_Searchbox form input[type='text']").on('input', function() {
    let isSet = $('.freeword input[name="s"]').val();
    // console.log(isSet.length);
    let value = $(this).val();
    if(isSet.length == 1 && count == 0) {
      $('<input type="hidden" name="s" value="'+value+'">').prependTo('.taxonomy');
      count ++;
    }
    if(!value){
      $('.taxonomy input[name="s"]').remove();
      count = 0;
    } else {
      $('.taxonomy input[name="s"]').val(value);
    }
  });
};



// ------------------------------------------------------------------------
// langToggle
// ----- BOTH
// ------------------------------------------------------------------------
const langToggle = () => {
  $(".st-Header_Lang p").on("click", function() {
    $(this).parent().toggleClass("open");
  });
};



// ------------------------------------------------------------------------
// srchToggle
// ----- BOTH
// ------------------------------------------------------------------------
const srchToggle = () => {
  $(".sw-Game_Searchbox_Toggle").on("click", function() {
    $(this).toggleClass("open");
    $(this).next().toggleClass("open");
    $(this).next().slideToggle(300);
  });
};



// ------------------------------------------------------------------------
// menuToggle
// ----- BOTH
// ------------------------------------------------------------------------
const menuToggle = () => {
  $(".header-hamburger").on("click", function() {
    $(this).toggleClass("open");
    $(".st-Header_Nav").toggleClass("open");
  });
};



export {
  loading,
  anchorLink,
  resizeHeader,
  mainSlider,
  movieSlider,
  recoSlider,
  accToggle,
  scrlInit,
  inputSync,
  langToggle,
  srchToggle,
  menuToggle
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js